<template>
  <div class="subs-delete" @click.stop.prevent>
    <div class="subs-delete-subs text-dark" v-if="isLoading">
      <div class="subs-delete-subs__loader marg-2-top" v-if="isLoading">
        <h3 class="text-explainer">{{ $t('vue2.subs_ongoing_absence.checking_for_substitutes') }}</h3>
        <Loader style="margin-top: 1rem" :isSmall="true"></Loader>
      </div>
    </div>
    <div class="input-group-subs" v-if="!isLoading && eventsSortedInDays.length < 1">
      <label class="d-label">{{ $t('vue2.subs_ongoing_absence.lessons_with_substitutes') }}</label>
      <p class="text-explainer">{{ $t('vue2.subs_ongoing_absence.no_subs_on_lessons') }}</p>
    </div>
    <div v-if="!isLoading && eventsSortedInDays.length > 0" class="marg-1-top">
      <div class="subs-days-container__header">
        <label class="d-label">{{ eventsWithSubstitutes.length }}
          {{ $t('vue2.subs_ongoing_absence.lessons_with_substitutes') }}</label>
        <p class="select-all-item" @click="toggleAll">
          <span v-if="eventsToRemovedSubs.length === 0">{{ $t('vue2.subs_ongoing_absence.select_all') }}</span>
          <span v-else>{{ $t('vue2.subs_ongoing_absence.unselect_all') }}</span>
        </p>
      </div>
      <ul class="subs-days-container rounded shadow">
        <li v-for="day in eventsSortedInDays">
          <div class="day__header">
            <label>{{ day.date | ddd | capitalize }}, {{ day.date | LL }}</label>
            <label>{{ $t('vue2.subs_ongoing_absence.remove_sub') }}</label>
          </div>
          <ul class="sub-lessons">
            <li v-for="event in day.events"
                :key="event.event_id"
                class="d-lesson"
                :class="{'d-lesson--active': isInEventsToRemovedSubs(event)}"
                :style="{'border-color': event.color}"
                @click.stop.prevent="toggleEvent(event)">
              <div class="d-lesson__title">
                <span class="d-lesson__time">{{ event.start | LT }} - {{ event.end | LT }}</span>
                {{ event.title }}, <span v-for="klass in getClasses(event)"> {{ klass.name }}</span>
              </div>
              <div class="sub-selector">
                <p v-for="sub in getSubstitute(event)" class="sub-name">
                  <b>{{ sub.name }}</b>
                </p>
                <div class="d-checkbox" :class="{'d-checkbox--active': isInEventsToRemovedSubs(event)}"></div>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="subs-delete__footer" v-if="eventsToRemovedSubs.length !== 0 || eventsWithSubstitutes.length !== 0">
      <h4>{{ eventsToRemovedSubs.length }} {{ $t('vue2.subs_ongoing_absence.of') }} {{ eventsWithSubstitutes.length }}
        {{ $t('vue2.subs_ongoing_absence.lessons_that_will_have_subs_removed') }}</h4>
    </div>
  </div>
</template>

<script>
import docendo from '../../docendo'
import Loader from '../common/Loader'
import moment from 'moment'
import Lesson from '../Hours/Lesson'
import {mapGetters} from 'vuex'

export default {
  components: {Loader, Lesson},
  props: {
    calendarId: {},
    firstRange: {},
    lastRange: {},
    dates: {
      default: () => []
    },
    startTime: {},
    endTime: {}
  },
  data () {
    return {
      events: [],
      eventsWithSubstitutes: [],
      eventsToRemovedSubs: [],
      isLoading: true
    }
  },
  computed: {
    ...mapGetters([
      'allUsersInHash',
      'allUsersInCalIdHash',
      'allKlassCalendarsInHash',
      'allCalendarsInHash'
    ]),
    sortedEvents () {
      let arr = this.eventsWithSubstitutes
      return arr.sort((a, b) => {
        return moment(a.start).unix() - moment(b.start).unix()
      })
    },
    eventsSortedInDays () {
      let sortedEventsInDays = this.sortedEvents.reduce((acc, curr, index) => {
        let val = moment(curr['start']).format('YYYY-MM-DD')
        acc[val] = acc[val] || []
        acc[val].push(curr)
        return acc
      }, {})
      return this.eventsToArr(sortedEventsInDays)
    }
  },
  watch: {
    dates () {
      this.getAllEventsInPeriod()
    },
    eventsWithSubstitutes (val) {
      this.$emit('lessonsWithSubs', val)
    }
  },
  methods: {
    setDbDateTime (inputDate, dayTime) {
      let date = moment(inputDate).format('YYYY-MM-DD')
      let time = moment(dayTime).locale('LT')
      return moment(date).set({
        hour: time.get('hour'),
        minutes: time.get('minutes')
      })
    },
    readEvents (start, end) {
      const dbStart = this.setDbDateTime(start, moment().startOf('day'))
      const dbEnd = this.setDbDateTime(end, moment().endOf('day'))
      docendo.eventsFromCalendars([this.calendarId], dbStart, dbEnd, null, success => {
        this.isLoading = false
        const data = success && success.length > 0 ? JSON.parse(success) : []
        data.forEach(lesson => {
          this.events.push(lesson)
          lesson.calendars.forEach(calendar => {
            if (calendar.substitute && calendar.substitute === this.allUsersInCalIdHash[this.calendarId].id) {
              this.eventsWithSubstitutes.push(lesson)
              this.toggleEvent(lesson)
            }
          })
        })
        this.$emit('gotLessons', true)
      }, failure => {
        console.log('failed', failure)
      })
    },
    eventsToArr (events) {
      return Object.keys(events).map(e => {
        return {date: e, events: events[e]}
      })
    },
    getSubstitute (event) {
      let subs = event.calendars.filter(calendar => calendar.substitute === this.allUsersInCalIdHash[this.calendarId].id)
      return subs.map(calendar => this.allUsersInCalIdHash[calendar.calendar_id])
    },
    getClasses (event) {
      return event.calendars.filter(calendar => this.allKlassCalendarsInHash[calendar.calendar_id]).map(calendar => this.allKlassCalendarsInHash[calendar.calendar_id])
    },
    isInEventsToRemovedSubs (lesson) {
      const idx = this.eventsToRemovedSubs.findIndex(currentEvent => currentEvent.event_id === lesson.event_id)
      return idx > -1
    },
    toggleEvent (lesson) {
      const idx = this.eventsToRemovedSubs.findIndex(currentEvent => currentEvent.event_id === lesson.event_id)
      if (idx < 0) {
        this.eventsToRemovedSubs.push(lesson)
      } else {
        this.eventsToRemovedSubs.splice(idx, 1)
      }
      this.$emit('changed', this.eventsToRemovedSubs)
    },
    toggleAll () {
      if (this.eventsToRemovedSubs.length > 0) {
        this.eventsToRemovedSubs = []
      } else {
        this.eventsWithSubstitutes.forEach(event => this.eventsToRemovedSubs.push(event))
      }
      this.$emit('changed', this.eventsToRemovedSubs)
    },
    getAllEventsInPeriod () {
      this.events = []
      if (this.firstRange.length > 0) {
        this.readEvents(this.firstRange[0], this.firstRange[1])
      }
      if (this.lastRange.length > 0) {
        this.readEvents(this.lastRange[0], this.lastRange[1])
      }
      if (!this.firstRange && !this.lastRange && this.dates) {
        let moments = this.dates.map(d => moment(d))
        let startDate = moment.min(moments)
        let endDate = moment.max(moments)
        if (this.dates.length === 1) {
          this.readEvents(moment(this.dates[0]).startOf('day'), moment(this.dates[0]).endOf('day'))
        } else {
          this.readEvents(moment(startDate).startOf('day'), moment(endDate).endOf('day'))
        }
      }
    }
  },
  mounted () {
    this.getAllEventsInPeriod()
  }
}
</script>

<style>
@import "../../assets/css/variables.css";

.subs-delete {
  border-radius: 4px;
  margin-top: 1rem;
}

.subs-days-container {
  max-height: 50vh;
  overflow-y: auto;
}

.subs-delete-subs {
  display: flex;
  min-height: 60px;
  margin-top: 1rem;
}

.day__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--border-color);
  padding: 0.5rem 1rem;
  background: #f9fafb;
}

.day__header label {
  font-size: .9rem;
  line-height: 1rem;
  font-weight: 700;
  display: block;
  color: #697386;
  padding: 0.25rem 0;
}

.sub-lessons {
  margin: 0;
}

.sub-lessons li:not(:last-child) {
  border-bottom: 1px solid var(--border-color) !important;
}

.d-lesson {
  display: flex;
  padding: 0.5rem 1rem;
  justify-content: space-between;
  cursor: pointer;
  background: #ffffff;
  border-left: 2px solid;
}

.d-lesson__title {
  display: flex;
  align-items: center;
}

.d-lesson__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: aliceblue;
  margin-right: 0.5rem;
}

.d-lesson__time {
  font-size: 0.9rem;
  margin-right: 0.5rem;
}

.sub-lessons li.d-lesson.d-lesson--active {
  background: aliceblue;
}

.select-all-item {
  cursor: pointer;
  color: var(--blue);
}

.select-all-item:hover {
  text-decoration: underline;
}

.sub-selector {
  display: flex;
  align-items: center;
}

.d-checkbox {
  position: relative;
  margin-left: 1rem;
  height: 12px;
  width: 12px;
  border: 1px solid var(--border-color);
  border-radius: 2px;
  padding: 2px;
}

.d-checkbox.d-checkbox--active {
  background: var(--blue);
  border-color: var(--blue);
}

.d-checkbox:after, .d-checkbox:before {
  transform: rotate(35deg);
}

.d-checkbox:after {
  content: '';
  display: block;
  width: 2px;
  height: 8px;
  background: #ffffff;
  position: absolute;
  top: 1px;
  right: 3px;
}

.d-checkbox:before {
  content: '';
  display: block;
  width: 4px;
  height: 2px;
  background: #ffffff;
  position: absolute;
  bottom: 3px;
  right: 5px;
}

.subs-days-container__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.subs-days-container__header label {
  color: #808692;
  font-weight: normal;
  font-size: 1rem;
}

.subs-delete__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 0.5rem;
}

</style>



// WEBPACK FOOTER //
// SubsDeleteAbsenceSubs.vue?e8f5fb34